<template>
  <header id="header" class="dynassurance">
    <!-- Top Bar: Contains user info, welcome message, and commission balances -->
    <div
      class="top_bar v2-top-bar mobile_wpml_hidden mobile_contacts_hidden mobile_socials_hidden mobile_cart_hidden mobile_search_hidden">
      <div class="container">
        <div class="top_bar_info_wr redesigned-header-top">

          <!-- Left: Welcome Message -->
          <div class="header-top-left">
            <div class="header-welcome-container">
              <i class="stm-clock6 header-icon"></i>
              <span class="welcome-text">
                Bienvenue <strong>{{ mechanicGarage }} - {{ mechanicCode }}</strong>
              </span>
            </div>
          </div>

          <!-- Right: Commissions, Button, and Profile -->
          <div class="header-top-right">
            <!-- Monthly Commissions Section -->
            <div class="commissions-group"
              v-if="isClientMonthlyPayment && (!$store.getters.isContact || isRepresentative)">
              <div class="commission-title">Commissions</div>
              <div class="commission-data">
                <span>
                  <label>Disponibles:</label>
                  <span class="value">{{ monthlyQuoteCommissionBalances.available }} €</span>
                </span>
                <span>
                  <label>En Réserve:</label>
                  <span class="value">{{ monthlyQuoteCommissionBalances.reserved }} €</span>
                </span>
              </div>
            </div>

            <!-- Virement CTA -->
            <div class="virement-button-box" v-if="monthlyQuoteCommissionBalances.available >= 300">
              <button class="btn-virement-cta" @click="requestWire">
                Virement de mes commissions
              </button>
            </div>

            <!-- User Profile Dropdown -->
            <div class="header-user-profile top_bar_info_switcher">
              <div class="active profile-trigger">
                <i class="fa fa-user-circle user-avatar-icon"></i>
                <span class="user-name">{{ mechanicName }}</span>
                <i class="fa fa-chevron-down"></i>
              </div>
              <ul style="display: none;">
                <li v-if="$can('read', 'account_representative') && !is_MUTUAIDE_commercial">
                  <router-link to="/my-account-representative">Mon compte</router-link>
                </li>
                <li v-else-if="!$can('read', 'account_representative')">
                  <router-link to="/my-account">Mon compte</router-link>
                </li>
                <li v-if="$can('read', 'account_representative') && !is_MUTUAIDE_commercial">
                  <router-link to="/my-documents">Mes documents</router-link>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="$root.logOut">Déconnexion</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="header-box">
      <div class="container">
        <!-- Logo Section: Displays different logos based on partner type (Saga, Sarrut, etc.) -->
        <div class="logo-box" style="margin: 10px 0 10px;" v-if="is_Saga">
          <div class="logo logo-desktop">
            <a href="https://www.sagaenligne.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/img/saga.png" style="width: 100px;" alt="saga">
            </a>
          </div>
          <div class="logo logo-mobile">
            <a href="https://www.sagaenligne.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/img/saga.png" style="width: 100px; height: px;" alt="saga">
            </a>
          </div>
          <div class="menu-toggle">
            <button>&nbsp;</button>
          </div>
        </div>
        <div class="logo-box" style="margin: 10px 0 10px;" v-else-if="isDentalRepresentative">
          <div class="logo logo-desktop">
            <a href="/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/img/henri-schein.jpg" style="width: 100px;" alt="henri-schein">
            </a>
          </div>
          <div class="logo logo-mobile">
            <a href="/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/img/henri-schein.jpg" style="width: 100px; height: px;" alt="henri-schein">
            </a>
          </div>
          <div class="menu-toggle">
            <button>&nbsp;</button>
          </div>
        </div>
        <div class="logo-box" style="margin: 10px 0 10px;" v-else-if="isMegaDental">
          <div class="logo logo-desktop">
            <a href="/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/mega_dental.png" alt="mega_dental" width="60%">
            </a>
          </div>
          <div class="logo logo-mobile">
            <a href="/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/mega_dental.png" alt="mega_dental" width="60%">
            </a>
          </div>
          <div class="menu-toggle">
            <button>&nbsp;</button>
          </div>
        </div>
        <div class="logo-box" style="margin: 10px 0 10px;" v-else-if="isSimplicicar">
          <div class="logo logo-desktop">
            <a href="/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/simplicicar.png" alt="simplicicar" width="120px">
            </a>
          </div>
          <div class="logo logo-mobile">
            <a href="/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/simplicicar.png" alt="simplicicar" width="120px">
            </a>
          </div>
          <div class="menu-toggle">
            <button>&nbsp;</button>
          </div>
        </div>
        <div class="logo-box" v-else>
          <div class="logo logo-desktop" v-if="is_Sarrut">
            <a href="https://sarrut-assurances-sp.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/img/sarrut.jpg" style="width: 300px;" alt="sarrut">
            </a>
          </div>
          <div class="logo logo-desktop" v-else-if="is_LeMondeCampingCar">
            <a href="https://sarrut-assurances-sp.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/img/lemonde.png" style="width: 300px;" alt="lemonde">
            </a>
          </div>
          <div class="logo logo-desktop" v-else-if="isSpecialite == 'Camping-Car'">
            <a href="https://assur-camping-car.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/assurance_camping_car_logo.png" style="width: 220px;" alt="assur-camping-car">
            </a>
          </div>
          <div class="logo logo-desktop" v-else>
            <router-link to="/" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/assur_logo.jpg" style="width: 300px;">
            </router-link>
          </div>
          <div class="logo logo-mobile" v-if="is_Sarrut">
            <a href="https://sarrut-assurances-sp.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/img/sarrut.jpg" style="width: 250px;" alt="sarrut">
            </a>
          </div>
          <div class="logo logo-mobile" v-else-if="is_LeMondeCampingCar">
            <a href="https://sarrut-assurances-sp.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/img/lemonde.png" style="width: 250px;" alt="lemonde">
            </a>
          </div>
          <div class="logo logo-mobile" v-else-if="isSpecialite == 'Camping-Car'">
            <a href="https://assur-camping-car.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/assurance_camping_car_logo.png" style="width: 250px;" alt="assur-camping-car">
            </a>
          </div>
          <div class="logo logo-mobile" v-else>
            <router-link to="/" style="margin: 0px 0px 0px 0px;">
              <img src="../../../assets/assur_logo.jpg" style="width: 250px;">
            </router-link>
          </div>
          <div class="menu-toggle">
            <button>&nbsp;</button>
          </div>
        </div>
        <div class="logo-mutuaide" v-if="is_MUTUAIDE_representative || is_MUTUAIDE_commercial || $can('be', 'broker')">
          <a href="https://www.mutuaide.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
            <img src="../../../assets/img/logo_mut.jpg" style="width: 100px;" alt="mutuaide">
          </a>
        </div>
        <div class="logo-truffaut" v-if="$can('be', 'garden')">
          <a href="https://www.truffaut.com/" target="_blank" style="margin: 0px 0px 0px 0px;">
            <img src="../../../assets/img/truffaut.jpg" style="width: 200px;" alt="truffaut">
          </a>
        </div>
        <!-- Main Navigation: Dynamically populated based on user role and permissions -->
        <div class="nav-box affix-top">
          <ul id="menu-menu-principal" class="main_menu_nav">
            <li><router-link to="/">Tableau de bord</router-link></li>
            <li class="menu-item-has-children highlighted"><router-link :to="menuItems[0].url">Nouvelle
                garantie</router-link>
              <ul class="sub-menu">
                <li v-for="item in menuItems" :key="item.name">
                  <template v-if="item.style && item.style === 'disabled'">
                    <router-link :to="item.url" style="color: gray; cursor: default; pointer-events: none;">
                      {{ item.name }}
                    </router-link>
                  </template>

                  <template v-else>
                    <router-link :to="item.url">
                      <span v-if="item.url.includes('garantie-auto-mensualisee')" class="text-danger font-weight-bold">
                        Nouveau :
                      </span>
                      {{ item.name }}
                    </router-link>
                  </template>
                </li>

              </ul>
            </li>
            <li class="menu-item-has-children"><router-link :to="recherchePreparedList[0].url">Recherche</router-link>
              <ul class="sub-menu">
                <li v-for="item in recherchePreparedList" :key="item.name">
                  <router-link :to="item.url">{{ item.name }}</router-link>
                </li>
                <li v-if="isMutuaiderepresentative && !isMutuaidecommercial">
                  <a @click="exportParc" style="cursor: pointer;">Export du Parc Actif</a>
                </li>
                <li v-if="isMutuaiderepresentative && !isMutuaidecommercial">
                  <a @click="exportParcComplete" style="cursor: pointer;">Export du Parc Complet</a>
                </li>
              </ul>
            </li>
            <!-- Partner area menu -->
            <li class="menu-item-has-children">
              <a href="#">Mon espace partenaire</a>

              <ul class="sub-menu">

                <!-- Account -->
                <li v-if="$can('read', 'account_representative') && !isMutuaidecommercial">
                  <router-link to="/my-account-representative">Mon compte</router-link>
                </li>
                <li v-else-if="!isMutuaidecommercial">
                  <router-link to="/my-account">Mon compte</router-link>
                </li>

                <!-- Reversement -->
                <li v-if="isMutuaideAssistance">
                  <router-link to="/bordereaux-reversement">
                    Bordereaux de reversement
                  </router-link>
                </li>

                <!-- Representative commissions -->
                <li v-if="(!$store.getters.isContact || isRepresentative) && isClientMonthlyPayment">
                  <router-link to="/commissions-mensuelles">
                    Commissions
                  </router-link>
                </li>

                <!-- Representative invoices -->
                <li v-if="!$store.getters.isContact || isRepresentative">
                  <router-link to="/factures">
                    Factures
                  </router-link>
                </li>

                <!-- Representative incentive plan -->
                <li v-if="(!$store.getters.isContact || isRepresentative) && isClientMonthlyPayment">
                  <router-link to="/plan-dinteressement">
                    Plan d’intéressement
                  </router-link>
                </li>

                <!-- Documentation -->
                <li v-if="isMutuaide || isMutuaiderepresentative || isMutuaidecommercial">
                  <router-link to="/documentations">
                    Dispositions Générales
                  </router-link>
                </li>

                <!-- User documents -->
                <li v-if="$can('read', 'account_representative') &&
                  !isMutuaidecommercial &&
                  !isMutuaiderepresentative">
                  <router-link to="/my-documents">
                    Mes documents
                  </router-link>
                </li>

                <!-- Representative commission statements -->
                <li
                  v-if="(!$store.getters.isContact || isRepresentative) && (isClientMonthlyPayment || mechanicClientPayment)">
                  <router-link to="/representative-commission">
                    Bordereaux de Commissions
                  </router-link>
                </li>

                <!-- Logout -->
                <li>
                  <a href="#" @click="$root.logOut">
                    Deconnexion
                  </a>
                </li>

              </ul>
            </li>
          </ul>
        </div>
        <div class="socials-box hide_on_mobile">
          <a target="_blank" href="https://twitter.com/dynassurances">
            <i class="fa fa-twitter">&nbsp;</i>
          </a>
          <a target="_blank" href="https://www.facebook.com/Dynassurances/">
            <i class="fa fa-facebook">&nbsp;</i>
          </a>
          <a target="_blank" href="https://www.linkedin.com/company/dynassurances">
            <i class="fa fa-linkedin">&nbsp;</i>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "DynassurancesV2",
  props: {
    mechanicName: {
      default: '',
      type: String
    },
    mechanicGarage: {
      default: '',
      type: String
    },
    mechanicCode: {
      default: '',
      type: String
    },
    monthlyQuoteCommissionBalances: {
      type: Object,
      default: () => ({ available: 0, reserved: 0 })
    }
  },
  data() {
    return {
      // Menu items for standard Mechanics
      mechanicItems: [
        { name: 'Garantie VP - VU - 4x4', url: '/garantie-auto-v2' },
        { name: 'Garantie Camping Car', url: '/garantie-camping-car-v2' },
        { name: 'Garantie Moto', url: '/garantie-moto-v2' },
        { name: 'Assurance Temporaire', url: '/assurance-temporaire' },
      ],
      grossisteItems: [
        { name: 'Garantie VP - VU - 4x4', url: '/garantie-autos' },
        { name: 'Garantie Camping Car', url: '/garantie-camping-cars', style: 'disabled' },
        { name: 'Garantie Moto', url: '/garantie-motos', style: 'disabled' },
        { name: 'Assurance Temporaire', url: '/assurance-temporaire', style: 'disabled' },
      ],
      sagaItems: [
        { name: 'Garantie VP - VU - 4x4', url: '/garantie-auto-v2' },
        { name: 'Garantie Camping Car', url: '/garanties-camping-car-v2', style: 'disabled' },
        { name: 'Garantie Moto', url: '/garanties-moto-v2', style: 'disabled' },
        { name: 'Assurance Temporaire', url: '/assurance-temporaire', style: 'disabled' },
      ],
      leMondeCampaignCarItems: [
        { name: 'Garantie VP - VU - 4x4', url: '/garantie-autos', style: 'disabled' },
        { name: 'Garantie Camping Car', url: '/garantie-camping-car', },
        { name: 'Garantie Moto', url: '/garantie-motos', style: 'disabled' },
        { name: 'Assurance Temporaire', url: '/assurance-temporaire', style: 'disabled' },
      ],
      brokerItems: [
        { name: 'Assistance Autocars', url: '/assistance-autocars' },
        { name: 'Assistance Poids Lourds', url: '/assistance-poids-lourds' },
        { name: 'Assistance Taxi-Ambulance-VSL-Corbillard', url: '/assistance-vsl' },
        { name: 'Assistance VP- VUL - 4097', url: '/assistance-vul4097' },
      ],
      Items4097: [
        { name: 'Assistance VP- VUL - 4097', url: '/assistance-vul4097' },
      ],
      mutuaideItems: [
        { name: 'Assistance Autocars', url: '/assistance-autocars' },
        { name: 'Assistance Poids Lourds', url: '/assistance-poids-lourds' },
        { name: 'Assistance Taxi-Ambulance-VSL-Corbillard', url: '/assistance-vsl' },
        { name: 'Assistance VP- VUL - 4097', url: '/assistance-vul4097' },
      ],
      dealerItems: [
        { name: 'Garantie Camping Car', url: '/garantie-camping-car-dealer' },
        { name: 'MASTERS Assurance', url: '/devis-en-ligne-assurance' },
      ],
      gardenItems: [
        { name: 'Garantie Outils de Jardin', url: '/garantie-outils-jardin' },
      ],
      representativeItems: [
        { name: 'Importer des garanties', url: '/garantie-import' },
      ],
      mechanicTestItems: [
        { name: 'Garantie VP - VU - 4x4', url: '/garantie-auto-v2' },
        { name: 'Garantie Camping Car', url: '/garantie-camping-car-v2' },
        { name: 'Garantie Moto', url: '/garantie-moto-v2' },
        { name: 'Assurance Temporaire', url: '/assurance-temporaire' },
        // { name: 'Devis en ligne Assurance', url: '/devis-en-ligne-assurance' },
      ],
      // Search/Management menu options (Standard)
      rechercheList: [
        { name: 'Devis Garanties', url: '/devis' },
        { name: 'Garanties souscrites', url: '/garantie-souscrites' },
        { name: 'Clients', url: '/clients' },
        { name: 'Statistiques avancées', url: '/stats' },
      ],
      rechercheDealerList: [
        { name: 'Devis Garanties', url: '/devis' },
        { name: 'Garanties souscrites', url: '/garantie-souscrites' },
        { name: 'Devis Assurance', url: '/devis-insurances' },
        { name: 'Assurances Souscrites', url: '/devis-insurances-souscrites' },
        { name: 'Clients', url: '/clients' },
        { name: 'Statistiques avancées', url: '/stats' },
      ],
      rechercheBrokerList: [
        { name: 'Devis Assistance', url: '/devis-assistance' },
        { name: 'Assistances souscrites', url: '/assistances-souscrite' },
        { name: 'Clients', url: '/clients-assistance' },
        { name: 'Statistiques avancées', url: '/stats-assistance' },
      ],
      rechercheMutuaideList: [
        { name: 'Devis Assistance', url: '/devis-assistance' },
        { name: 'Assistances souscrites', url: '/assistances-souscrite' },
        { name: 'Clients', url: '/clients-assistance' },
        { name: 'Statistiques avancées', url: '/stats-assistances' },
      ],
      representativeRecherchePreparedItems: [
        { name: 'Devis Garanties', url: '/devis' },
        { name: 'Garanties souscrites', url: '/garantie-souscrites' },
        { name: 'Clients', url: '/clients' },
        { name: 'Statistiques avancées', url: '/stats' },
      ],
      representativeMutuaideRecherchePreparedItems: [
        { name: 'Assistances souscrites', url: '/assistances-souscrites' },
      ],
      representativeSarrutRecherchePreparedItems: [
        { name: 'Devis Garanties', url: '/devis' },
        { name: 'Garanties souscrites', url: '/garantie-souscrites' },
        { name: 'Clients', url: '/clients' },
        { name: 'Statistiques avancées', url: '/stats' },
      ],
    }
  },
  computed: {
    /* 
     * Determines which "Nouvelle garantie" menu to show based on user store getters (Representative, Broker, Dealer, etc.)
     */
    menuItems() {
      // 1. FOR SARRUT ADMINS (GROSSISTE): Check if user is a representative and a Sarrut admin
      if (this.$store.getters.isRepresentative && this.$store.getters.isSarrutAdmin) {
        return this.filterBySpecialite(this.grossisteItems);
      }
      // 2. FOR SAGA ADMINS: Check if user is a representative and a Saga admin
      else if (this.$store.getters.isRepresentative && this.$store.getters.isSagaAdmin) {
        return this.filterBySpecialite(this.sagaItems);
      }
      // 3. FOR GENERAL REPRESENTATIVES: Check if user is a representative (standard)

      else if (this.$store.getters.isRepresentative && !this.isSimplicicar) {
        return this.filterBySpecialite(this.representativeItems);
      }
      // 4. FOR SARRUT PARTNERS: Check if user is linked to Sarrut
      else if (this.$store.getters.isSarrut) {
        return this.filterBySpecialite(this.grossisteItems);
      }
      // 5. FOR SAGA PARTNERS: Check if user is linked to Saga
      else if (this.$store.getters.isSaga) {
        return this.filterBySpecialite(this.sagaItems);
      }
      // 6. FOR LE MONDE CAMPING CAR: Check if user belongs to this specific partner
      else if (this.$store.getters.isLeMondeCampingCar) {
        return this.filterBySpecialite(this.leMondeCampaignCarItems);
      }
      // 7. FOR BROKERS: Check if user is a broker (courtier)
      else if (this.$store.getters.isBroker) {
        return this.filterBySpecialite(this.brokerItems);
      }
      // 8. FOR 4097 SPECIFIC PARTNERS: Check for the 4097 permission/flag
      else if (this.$store.getters.is4097) {
        return this.filterBySpecialite(this.Items4097);
      }
      // 9. FOR MUTUAIDE PARTNERS: Check if user belongs to Mutuaide
      else if (this.$store.getters.isMutuaide) {
        return this.filterBySpecialite(this.mutuaideItems);
      }
      // 10. FOR GARDEN PARTNERS: Check if user is a garden partner (e.g., Truffaut)
      else if (this.$store.getters.isGarden) {
        return this.filterBySpecialite(this.gardenItems);
      }
      // 11. FOR DEALERS: Check if dealer or specific mechanic ID (3909)
      else if (this.$store.getters.isDealer || (this.$store.getters.getMechanic && +this.$store.getters.getMechanic.id === 3909)) {
        return this.filterBySpecialite(this.dealerItems);
      }
      // 12. FOR SPECIFIC TEST MECHANICS (ID 325 or 321): With optional monthly payments
      else if (this.$store.getters.getMechanic && (this.$store.getters.getMechanic.id === 325 || this.$store.getters.getMechanic.id === 321)) {
        if (this.isClientMonthlyPayment) {
          return this.filterBySpecialite(this.insertAtSecondLast(this.mechanicTestItems, {
            name: 'Garantie Mensualisée',
            url: '/garantie-auto-mensualisee-v2'
          }));

        }
        return this.filterBySpecialite(this.mechanicTestItems);
      }
      // 13. DEFAULT FOR STANDARD MECHANICS: With optional monthly payments
      else {
        if (this.isClientMonthlyPayment) {
          return this.filterBySpecialite(this.insertAtSecondLast(this.mechanicTestItems, {
            name: 'Garantie Mensualisée',
            url: '/garantie-auto-mensualisee-v2'
          }));

        }
        return this.filterBySpecialite(this.mechanicItems);
      }
    },


    /* 
     * Determines which "Recherche" (Search) menu options to show based on user role
     */
    recherchePreparedList() {
      // 1. FOR MUTUAIDE REPRESENTATIVES: Specific owner type for Mutuaide
      if (this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.owner_type == 3)) {
        return this.representativeMutuaideRecherchePreparedItems;
      }
      // 2. FOR SARRUT REPRESENTATIVES: Specific representative IDs (58 or 61)
      else if (this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.id == 58 || this.$store.getters.getRepresentative.id == 61)) {
        return this.representativeSarrutRecherchePreparedItems;
      }
      // 3. FOR GENERAL REPRESENTATIVES: Standard search options
      else if (this.$store.getters.isRepresentative) {
        return this.representativeRecherchePreparedItems;
      }
      // 4. FOR DEALERS: Dealer-specific search/results
      else if (this.$store.getters.isDealer) {
        return this.rechercheDealerList;
      }
      // 5. FOR BROKERS: Broker-specific assistance search
      else if (this.$store.getters.isBroker) {
        return this.rechercheBrokerList;
      }
      // 6. FOR MUTUAIDE PARTNERS: General Mutuaide search list
      else if (this.$store.getters.isMutuaide) {
        return this.rechercheMutuaideList;
      }
      // 7. DEFAULT: Standard search options for Mechanics
      else {
        return this.rechercheList;
      }
    },
    /* Helper flags to check for specific partner IDs or types */
    isGUEMASrepresentative() {
      return this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.id == 12);
    },
    isMutuaideAssistance() {
      return this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.id == 13);
    },
    isMutuaiderepresentative() {
      return this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.owner_type == 3);
    },
    isMutuaidecommercial() {
      return this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.id == 15);
    },
    isMutuaide() {
      return this.$store.getters.isMutuaide;
    },
    isSpecialite() {
      return this.$store.getters.isSpecialite;
    },
    isRepresentative() {
      return this.$store.getters.isRepresentative;
    },
    is_MUTUAIDE_representative() {
      return this.$store.state.userInfo.representative ? (this.$store.state.userInfo.representative.id == 13) : false;
    },
    is_MUTUAIDE_commercial() {
      return this.$store.state.userInfo.representative ? (this.$store.state.userInfo.representative.id == 15) : false;
    },
    is_Sarrut() {
      if (this.$store.getters.isSarrutAdmin || this.$store.getters.isSarrut)
        return true;
      else
        return false;
    },
    is_HenriSchein() {
      if (this.$store.getters.isHenriScheinAdmin || this.$store.getters.isHenriSchein)
        return true;
      else
        return false;
    },
    is_Saga() {
      if (this.$store.getters.isSagaAdmin || this.$store.getters.isSaga)
        return true;
      else
        return false;
    },
    is_LeMondeCampingCar() {
      if (this.$store.getters.isLeMondeCampingCar)
        return true;
      else
        return false;
    },
    isClientMonthlyPayment() {
      return this.$store.getters.isClientMonthlyPayment;
    },
    isSarrutAdmin() {
      return this.$store.getters.isSarrutAdmin;
    },
    isSagaAdmin() {
      return this.$store.getters.isSagaAdmin;
    },
    mechanicClientPayment() {
      let client_payment =
        this.$store.state.userInfo && this.$store.state.userInfo.mechanic
          ? this.$store.state.userInfo.mechanic.client_payment
          : null;
      return client_payment ? client_payment : false;
    },
    isDentalRepresentative() {
      return this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.id == 64);
    },
    isMegaDental() {
      return this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.id == 65);
    },
    isSimplicicar() {
      return (
        (this.$store.state.userInfo &&
          this.$store.state.userInfo.mechanic &&
          this.$store.state.userInfo.mechanic.garage === 'SIMPLICICAR') ||

        (this.$store.getters.getRepresentative &&
          this.$store.getters.getRepresentative.name &&
          this.$store.getters.getRepresentative.name.includes('SIMPLICICAR')) ||

        (this.$store.getters.getRepresentative &&
          this.$store.getters.getRepresentative.id === 67)
      );
    }
  },
  methods: {
    filterBySpecialite(items) {
      const speciality = this.isSpecialite;

      const hiddenItems = {
        'Auto': ['Garantie Camping Car', 'Garantie Moto'],
        'Moto': ['Garantie Camping Car', 'Garantie VP - VU - 4x4', 'Garantie Mensualisée'],
        'Camping-Car': ['Garantie VP - VU - 4x4', 'Garantie Moto', 'Garantie Mensualisée']
      };

      return items.filter(
        item => !(hiddenItems[speciality] || []).includes(item.name)
      );
    },
    insertAtSecondLast(arr, item) {
      const index = arr.length - 1; // last se 2nd position
      return [
        ...arr.slice(0, index),
        item,
        ...arr.slice(index)
      ];
    },
    // Triggers a request for commission wire transfer
    requestWire() {
      this.$emit('requestWire');
    },
    // Mutuaide specific export functionality
    exportParc() {
      let url;
      if (this.$store.getters.getRepresentative.id != 13) {
        let representative_id = this.$store.getters.getRepresentative.id;
        url = 'mutuaide/export/parc_rep/' + representative_id;
      } else
        url = 'mutuaide/export/parc';
      window.location = this.getApiAuthUrl(url);
    },
    exportParcComplete() {
      let url
      if (this.$store.getters.getRepresentative.id != 13) {
        let representative_id = this.$store.getters.getRepresentative.id;
        url = 'mutuaide/export/parc_complete_rep/' + representative_id;
      } else
        url = 'mutuaide/export/parc_complete';
      window.location = this.getApiAuthUrl(url);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Headers/v2/Dynassurances.vue